import classNames from 'classnames';
import ImageEmpty from '../../../assets/image/shared/empty.svg';
import styles from './postInfo.module.scss';
type TPostInfoProps = {
  image: string;
  title: string;
};
const PostInfo = ({image, title}: TPostInfoProps) => {
  return (
    <>
      <div
        className={classNames(image ? 'w-50' : 'w-100', styles['post-info'])}
      >
        <div className="card w-100">
          {image ? (
            <div className="w-100 text-center">
              <img src={image} className="card-img-top m-auto" alt={title} />
            </div>
          ) : (
            <div className="w-100 text-center p-3">
              <img
                src={ImageEmpty}
                className="card-img-top  m-auto"
                alt={title}
              />
            </div>
          )}

          <div className="card-body w-100 d-flex text-end">
            <span className="card-text">{title}</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default PostInfo;
